<template>
    
    <div>
        
    
        <nav-bar-home></nav-bar-home>
        <main id="main" class="account dashboard">
            
            <section class="account-content parten-bg">
                <div class="container-fluid" >
                
                    <div class="row acc-dashboard">
                        
                        <section class="account-main col-md-12 col-xs-12">
                            <div class="row">
                                
                                <div class="col-12">
                                    <dashboard-stats></dashboard-stats>
                                </div>
                                
                            </div>
                            <div class="row db-content pb-1"><button class="btn btn-primary float-right" style="margin: 4px; " :class="{'active-tag':path == '/user-dashboard/addresses'}"  @click="goTo(path, '/user-dashboard/add-users')">Add User</button></div>
                            <h3 class="acc-title lg">My Users List </h3>
                            <div class="row db-content">
                                <app-loader v-if="isLoading" text="Loading users" />
                                <div v-else class="users-table-wrap">
                                <table class="invoice-table table users-table">
                                    <thead>
                                        <tr>
                                            <th>User ID</th>
                                            <th>FIRST NAME</th>
                                            <th>LAST NAME</th>
                                            <th>USERNAME</th>
                                            <th>EMAIL</th>
                                            <th>STATUS</th>
                                            <th>ACTION</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="processedSubUsers.length === 0">
                                            <td colspan="7" style="text-align: center;">No sub-users found.</td>
                                        </tr>
                                        <tr v-for="subUser in processedSubUsers" :key="subUser._id">
                                            <td>{{ subUser.userCode }}</td>
                                            <td>{{ subUser.name }}</td>
                                            <td>{{ subUser.lastName }}</td>
                                            <td>{{ subUser.username }}</td>
                                            <td>{{ subUser.email }}</td>
                                            <td>
                                                <span :class="subUser.isVerified ? 'users-badge-active' : 'users-badge-inactive'">
                                                    {{ subUser.isVerified ? 'Active' : 'Inactive' }}
                                                </span>
                                            </td>
                                            <td>
                                                <span class="users-view-btn" @click="openView(subUser)">View</span>
                                                <span class="users-edit-btn" @click="openEditModal(subUser)">Edit</span>
                                            </td>
                                            </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </section><!-- Cart main content : End -->
                    </div>
                    
                </div>
            </section>
        </main><!-- Main Category: End -->
        <!--Footer : Begin-->
        <div >
            <footer-section></footer-section>
        </div>
        <div class="modal-mask" v-if="showModal">
            <div class="modal-wrapper">
                <div class="modal-container users-modal-container">
                    <div class="modal-body">
                        <button class="btn btn-danger close-btn users-close-btn" @click="closeModal">
                            <b>&#10006;</b>
                        </button>
                        <h3 class="branch-title" style="text-align: center; font-weight: bold; font-size: 26px;">
                            {{ modalMode === 'edit' ? 'Edit Branch' : 'Branch Details' }}
                        </h3>
                        <br>
                        <div v-if="modalLoading" class="users-modal-loading">
                            <span class="users-modal-spinner"></span>
                            <span>Loading branch details...</span>
                        </div>
                        <template v-else>
                            <div v-if="modalMode === 'view'">
                                <div class="users-info-card">
                                    <div><strong>User ID:</strong> {{ activeBranch.userCode }}</div>
                                    <div><strong>Status:</strong>
                                        <span :class="branchDetails && branchDetails.isVerified ? 'users-badge-active' : 'users-badge-inactive'">
                                            {{ branchDetails && branchDetails.isVerified ? 'Active' : 'Inactive' }}
                                        </span>
                                    </div>
                                    <div><strong>First Name:</strong> {{ branchDetails ? branchDetails.name : '' }}</div>
                                    <div><strong>Last Name:</strong> {{ branchDetails ? branchDetails.lastName : '' }}</div>
                                    <div><strong>Business Name:</strong> {{ branchDetails ? branchDetails.accountTitle : '' }}</div>
                                    <div><strong>Username:</strong> {{ branchDetails ? branchDetails.username : '' }}</div>
                                    <div><strong>Email:</strong> {{ branchDetails ? branchDetails.email : '' }}</div>
                                </div>
                                <template v-if="branchDetails && branchDetails.address">
                                    <h4 class="acc-title h-icon">Branch Address</h4>
                                    <div class="users-info-card">
                                        <div><strong>Address Line 1:</strong> {{ branchDetails.address.addressOne }}</div>
                                        <div><strong>Address Line 2:</strong> {{ branchDetails.address.addressTwo }}</div>
                                        <div><strong>City/Town:</strong> {{ branchDetails.address.city }}</div>
                                        <div><strong>County:</strong> {{ branchDetails.address.county }}</div>
                                        <div><strong>Country:</strong> {{ branchDetails.address.country }}</div>
                                        <div><strong>Post Code:</strong> {{ branchDetails.address.postCode }}</div>
                                        <div><strong>Contact Name:</strong> {{ branchDetails.address.contactName }}</div>
                                        <div><strong>Mobile No:</strong> {{ formatMobile(branchDetails.address.mobileNumber) }}</div>
                                    </div>
                                </template>
                                <p v-else class="users-no-address">No address on file for this branch yet.</p>
                                <div class="users-modal-actions">
                                    <button class="btn btn-primary" @click="switchToEdit">Edit Branch</button>
                                </div>
                            </div>
                            <div v-else>
                                <div class="users-edit-grid">
                                    <div>
                                        <label>First Name</label>
                                        <input type="text" class="form-control" v-model="editForm.name">
                                    </div>
                                    <div>
                                        <label>Last Name</label>
                                        <input type="text" class="form-control" v-model="editForm.lastName">
                                    </div>
                                    <div>
                                        <label>Business Name</label>
                                        <input type="text" class="form-control" v-model="editForm.accountTitle">
                                    </div>
                                </div>
                                <h4 class="acc-title h-icon" style="margin-top: 20px;">Branch Address</h4>
                                <div class="users-edit-grid">
                                    <div>
                                        <label>Address Line 1</label>
                                        <input type="text" class="form-control" v-model="editForm.addressOne">
                                    </div>
                                    <div>
                                        <label>Address Line 2</label>
                                        <input type="text" class="form-control" v-model="editForm.addressTwo">
                                    </div>
                                    <div>
                                        <label>City/Town</label>
                                        <input type="text" class="form-control" v-model="editForm.city">
                                    </div>
                                    <div>
                                        <label>County</label>
                                        <input type="text" class="form-control" v-model="editForm.county">
                                    </div>
                                    <div>
                                        <label>Country</label>
                                        <input type="text" class="form-control" v-model="editForm.country">
                                    </div>
                                    <div>
                                        <label>Post Code</label>
                                        <input type="text" class="form-control" v-model="editForm.postCode">
                                    </div>
                                    <div>
                                        <label>Contact Name</label>
                                        <input type="text" class="form-control" v-model="editForm.contactName">
                                    </div>
                                    <div>
                                        <label>Mobile No</label>
                                        <input type="text" class="form-control" maxlength="11" v-model="editForm.mobileNumber"
                                            @input="editForm.mobileNumber = $event.target.value.replace(/[^0-9]/g, '').slice(0, 11)">
                                    </div>
                                </div>
                                <div class="users-modal-actions">
                                    <span class="text-danger" v-if="saveError" style="align-self: center; margin-right: auto;">{{ saveError }}</span>
                                    <button class="btn btn-secondary" :disabled="saving" @click="modalMode = 'view'">Cancel</button>
                                    <button class="btn btn-primary" :disabled="saving" @click="saveBranch">{{ saving ? 'Saving...' : 'Save Changes' }}</button>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </template>
    
    <script>
    // import VueHtml2pdf from 'vue-html2pdf'
    // import VueHtml2pdf from 'vue-html2pdf'
    // import html2pdf from "html2pdf.js";
    import jsPDF from 'jspdf'
    import NavBarHome from "@/components/NavBarHome.vue"
    import DashboardStats from "./DashboardStats.vue"
    import FooterSection from "@/components/FooterSection.vue"
    import AppLoader from "@/components/AppLoader.vue"
    import {mapState} from 'vuex'
    export default {
    components:{DashboardStats,NavBarHome, FooterSection, AppLoader},
    data() {
        return {
            isLoading: true,
            showModal: false,
            modalMode: 'view',
            modalLoading: false,
            activeBranch: null,
            branchDetails: null,
            saving: false,
            saveError: '',
            editForm: {
                name: '',
                lastName: '',
                accountTitle: '',
                addressId: null,
                addressOne: '',
                addressTwo: '',
                city: '',
                county: '',
                country: '',
                postCode: '',
                contactName: '',
                mobileNumber: '',
            },
        }
    },
    methods:{
        goTo(from, to){
            if (from !== to) {
                this.$router.push({path: to})
            }
        },
        formatMobile(value) {
            if (value === undefined || value === null) return '';
            let mob = String(value).trim();
            if (!mob.length || mob === 'undefined' || mob === 'null') return '';
            if (mob.startsWith('+') || mob.startsWith('0')) return mob;
            return '0' + mob;
        },
        lockScroll() {
            document.body.style.overflow = "hidden";
            document.body.style.position = "fixed";
            document.body.style.width = "100%";
        },
        unlockScroll() {
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.width = "";
        },
        async loadBranch(branch) {
            this.activeBranch = branch;
            this.branchDetails = null;
            this.modalLoading = true;
            this.showModal = true;
            this.saveError = '';
            this.lockScroll();
            this.branchDetails = await this.$store.dispatch("defaultBranchSwitchAddress", { slug: branch._id });
            this.modalLoading = false;
        },
        async openView(branch) {
            this.modalMode = 'view';
            await this.loadBranch(branch);
        },
        async openEditModal(branch) {
            this.modalMode = 'edit';
            await this.loadBranch(branch);
            this.seedEditForm();
        },
        seedEditForm() {
            const d = this.branchDetails || {};
            const addr = d.address || {};
            this.editForm = {
                name: d.name || '',
                lastName: d.lastName || '',
                accountTitle: d.accountTitle || '',
                addressId: addr._id || null,
                addressOne: addr.addressOne || '',
                addressTwo: addr.addressTwo || '',
                city: addr.city || '',
                county: addr.county || '',
                country: addr.country || '',
                postCode: addr.postCode || '',
                contactName: addr.contactName || '',
                mobileNumber: addr.mobileNumber || '',
            };
        },
        switchToEdit() {
            this.modalMode = 'edit';
            this.seedEditForm();
        },
        closeModal() {
            this.showModal = false;
            this.activeBranch = null;
            this.branchDetails = null;
            this.saveError = '';
            this.unlockScroll();
        },
        async saveBranch() {
            if (!this.activeBranch) return;
            this.saving = true;
            this.saveError = '';
            try {
                const userDec = await this.$store.dispatch("updateUserDetails", {
                    user: {
                        _id: this.activeBranch._id,
                        name: this.editForm.name,
                        lastName: this.editForm.lastName,
                        accountTitle: this.editForm.accountTitle,
                    }
                });
                if (!userDec.status) {
                    this.saveError = "Failed to update branch details.";
                    return;
                }
                const addressPayload = {
                    addressOne: this.editForm.addressOne,
                    addressTwo: this.editForm.addressTwo,
                    city: this.editForm.city,
                    county: this.editForm.county,
                    country: this.editForm.country,
                    postCode: this.editForm.postCode,
                    contactName: this.editForm.contactName,
                    mobileNumber: this.editForm.mobileNumber,
                };
                if (this.editForm.addressId) {
                    await this.$store.dispatch("updateBranchAddress", {
                        address: { _id: this.editForm.addressId, user: this.activeBranch._id, ...addressPayload }
                    });
                } else if (this.editForm.addressOne.length > 0) {
                    await this.$store.dispatch("addAddress", { user: this.activeBranch._id, ...addressPayload });
                }
                await this.$store.dispatch("getUser");
                this.closeModal();
            } catch (error) {
                this.saveError = "Something went wrong while saving.";
            } finally {
                this.saving = false;
            }
        },
    },
    computed:{
        ...mapState(['user', 'subChildUser']),

        processedSubUsers() {
            if (!Array.isArray(this.subChildUser)) {
                return [];
            }
            // Final, strictest check: Filter for objects that have a displayable username.
            // This treats any user object without a username as invalid.
            return this.subChildUser.filter(user => user && typeof user === 'object' && user.username);
        },

        path(){
            return this.$route.path
        },
    
    },
    async mounted(){
        this.isLoading = true;
        try {
            await this.$store.dispatch("getUser");
        } catch (error) {
            console.error("Failed to get user data on mount:", error);
        } finally {
            this.isLoading = false;
        }
    },
    beforeDestroy() {
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.width = "";
    },
    }
    </script>
    
    <style>
    .invoice-table tr{ border: 1px solid lightgrey;}
    .invoice-table th{
        font-weight:800;
        padding:8px;
    }
    .invoice-table td{
        padding:8px;
    }
    .invoice-table img { cursor: pointer;padding:2px;}
    .invoice-table img:hover { border:1px solid red;}

    .users-table-wrap {
        margin: 10px 0 20px;
        overflow: auto;
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 2px 14px rgba(0, 0, 0, 0.06);
        border: 1px solid #eee;
        width: 100%;
    }
    .users-table { margin: 0 !important; }
    .users-table thead th {
        background: #fff5f4 !important;
        color: #3a3a3a !important;
        text-transform: uppercase;
        font-size: 12px;
        letter-spacing: .04em;
        font-weight: 700 !important;
        padding: 14px 16px !important;
        white-space: nowrap;
        border: none !important;
        border-bottom: 2px solid #fd5b4e !important;
    }
    .users-table tbody td {
        padding: 14px 16px !important;
        font-size: 14px;
        vertical-align: middle;
        border-bottom: 1px solid #f0f0f0 !important;
        border-top: none !important;
    }
    .users-table tbody tr:last-child td { border-bottom: none !important; }
    .users-table tbody tr:nth-child(even) { background: #fafbfc; }
    .users-table tbody tr:hover { background: #fff4f2; }

    .users-badge-active, .users-badge-inactive {
        display: inline-block;
        padding: 4px 12px;
        border-radius: 20px;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: .02em;
    }
    .users-badge-active { background: #e8f5e9; color: #2e7d32; border: 1px solid #c8e6c9; }
    .users-badge-inactive { background: #f1f2f6; color: #5e6673; border: 1px solid #e0e3ea; }

    .users-view-btn, .users-edit-btn {
        display: inline-block;
        margin: 2px 6px 2px 0;
        padding: 5px 14px;
        border-radius: 20px;
        font-weight: 700;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: .02em;
        cursor: pointer;
        transition: background .2s ease, color .2s ease;
    }
    .users-view-btn { background: #f1f2f6; color: #5e6673; }
    .users-view-btn:hover { background: #5e6673; color: #fff; }
    .users-edit-btn { background: #fff0ee; color: #fd5b4e; }
    .users-edit-btn:hover { background: #fd5b4e; color: #fff; }

    .modal-mask {
        position: fixed;
        z-index: 999899989998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }
    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
    .modal-container {
        max-width: 900px;
        margin-left: auto;
        margin-right: auto;
        padding: 1px 0px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }
    .modal-body { margin: 0px 0; max-height: 90vh; overflow: auto; }
    .close-btn {
        padding: 3px 7px;
        font-size: 12px;
        line-height: 1.5;
        border-radius: 3px;
    }

    .users-modal-container {
        border-radius: 14px;
        overflow: hidden;
        box-shadow: 0 16px 40px rgba(0, 0, 0, 0.25);
    }
    .users-close-btn {
        float: right;
        margin: 20px 20px 0 0 !important;
        width: 32px;
        height: 32px;
        padding: 0 !important;
        border-radius: 50% !important;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        border: none;
    }
    .users-modal-loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 14px;
        min-height: 220px;
        padding: 40px 20px;
        color: #999;
        font-size: 14px;
    }
    .users-modal-spinner {
        width: 30px;
        height: 30px;
        border: 3px solid #f1f1f1;
        border-top-color: #fd5b4e;
        border-radius: 50%;
        animation: users-spin .7s linear infinite;
    }
    @keyframes users-spin {
        to { transform: rotate(360deg); }
    }
    .users-info-card {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px 30px;
        padding: 0 22px 18px;
        font-size: 14px;
    }
    .users-no-address {
        padding: 0 22px 18px;
        color: #999;
        font-style: italic;
    }
    .users-edit-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 14px 24px;
        padding: 10px 22px;
    }
    .users-edit-grid label {
        font-weight: 600;
        color: #555;
        font-size: 13px;
        margin-bottom: 6px;
        display: block;
    }
    .users-edit-grid input.form-control {
        border-radius: 8px;
        border: 1px solid #e3e3e3;
        transition: border-color .2s ease, box-shadow .2s ease;
    }
    .users-edit-grid input.form-control:focus {
        border-color: #fd5b4e;
        box-shadow: 0 0 0 3px rgba(253, 91, 78, 0.15);
        outline: none;
    }
    .users-modal-actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 12px;
        padding: 18px 22px 26px;
    }
    .users-modal-actions .btn {
        border-radius: 24px;
        padding: 9px 22px;
        font-weight: 600;
    }

    @media (max-width: 768px) {
        .users-info-card, .users-edit-grid {
            grid-template-columns: 1fr;
        }
    }
    </style>